module.exports = __webpack_public_path__ + "img/Financials_Icon.83b856a5.png";